/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { TalentPoolImportRow } from './talentPoolImportRow';

export interface TalentPoolImportRequest {
  /**
     * @minItems 1
     * @maxItems 1000
     */
  rows: TalentPoolImportRow[];
}
